import $ from "jquery"; 

class Search {
    //1. describe and initiate object
    constructor(){
        this.openSearchButton=$(".js-search-trigger");
        this.closeSearchButton=$(".close-search");
        this.searchOverlay=$(".search-wrapper");
        this.fullWrapper=$(".secondary-wrapper");
        this.searchField=$('#search');
        this.searchEmpty=$('.search-results-empty');
        this.searchLoad=$('.search-results-loading');
        this.searchResults=$('.search-results-return');
        this.listModal=$('#listSelectorModal');
        this.openListButton=$(".js-open-list-selector");
        this.closeListButton=$(".js-close-list-selector");
        this.typingTimer;
        this.previousValue;
        this.isLoading=false;
        ///Search Results
        this.albums=[$("#search-result-album-1"),$("#search-result-album-2"),$("#search-result-album-3"),$("#search-result-album-4"),$("#search-result-album-5"),$("#search-result-album-6")]
        this.albumsText=[$("#search-result-album-text-1"),$("#search-result-album-text-2"),$("#search-result-album-text-3"),$("#search-result-album-text-4"),$("#search-result-album-text-5"),$("#search-result-album-text-6")]
        this.albumsArtist=[$("#search-result-album-artist-1"),$("#search-result-album-artist-2"),$("#search-result-album-artist-3"),$("#search-result-album-artist-4"),$("#search-result-album-artist-5"),$("#search-result-album-artist-6")]
        this.albumsImgs=[$("#search-result-album-img-1"),$("#search-result-album-img-2"),$("#search-result-album-img-3"),$("#search-result-album-img-4"),$("#search-result-album-img-5"),$("#search-result-album-img-6")]
        this.albumsLinks=[$("#search-result-link-1"),$("#search-result-link-2"),$("#search-result-link-3"),$("#search-result-link-4"),$("#search-result-link-5"),$("#search-result-link-6")]
        //initialize events
        this.events();
    }

    //2. list all events
    events(){
        this.openSearchButton.on("click",this.openSearch.bind(this));
        this.closeSearchButton.on("click",this.closeSearch.bind(this));
        this.searchField.on("keyup",this.typingSearchLogic.bind(this))
    }
    //3. Methods or functions 
    openSearch(){
        this.listModal.addClass("display-none");
        this.searchOverlay.removeClass("display-none");
        this.fullWrapper.addClass("display-none");
        this.closeListButton.addClass("display-none");
        this.openListButton.removeClass("display-none");
    }
    closeSearch(){
        this.searchOverlay.addClass("display-none");
        this.fullWrapper.removeClass("display-none");
    }
    typingSearchLogic(){
        if(this.searchField.val()!= this.previousValue){
            clearTimeout(this.typingTimer);
            if(this.searchField.val()){
                if(this.isLoading==false){
                    for(var i=0;i<6;i++){
                        this.albumsLinks[i].addClass('display-none');
                    }
                    this.searchResults.addClass('display-none');
                    this.searchEmpty.addClass('display-none');
                    this.searchLoad.removeClass('display-none');
                    this.isLoading=true;
                }
                this.typingTimer=setTimeout(this.getSearchResults.bind(this),1000);
            }else{
                this.searchResults.addClass('display-none');
                this.searchEmpty.removeClass('display-none');
                this.searchLoad.addClass('display-none');
            }
        }

        this.previousValue=this.searchField.val();
    }
    getSearchResults(){
        $.getJSON(recordreviverData.root_url+'/wp-json/recordreviver/v1/search?term='+ this.searchField.val(),results=>{
            for(var i=0;i<results.albums.length;i++){
                if(i<6){
                    this.albumsLinks[i][0].href=results.albums[i].permalink;
                    this.albumsImgs[i][0].src=results.albums[i].image;
                    this.albumsLinks[i].removeClass('display-none');
                    this.albumsText[i][0].innerHTML = results.albums[i].title;
                    this.albumsArtist[i][0].innerHTML = results.albums[i].artist.toString();
                }     
            }
            this.searchResults.removeClass('display-none');
            this.searchLoad.addClass('display-none');
            this.searchEmpty.addClass('display-none');
            this.isLoading=false;
        });

    }

}

export default Search;